export function getInitials(fullName: string): string {
    return fullName.split(/[^\w]+/).reduce((result, part) => {
        if (result.length < 3 && part.length > 0) {
            return result + part[0]?.toUpperCase();
        } else {
            return result;
        }
    }, "");
}
